// features/map/mapSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MapDetails2, MapDetails3 } from '../types';
import { DEFAULT_ICON_TYPE } from '../../utils/const';

interface MapState {
  zoomLevel: number;
  mapDetails: MapDetails3[];
  isPickUpSelected: boolean;
  isDropOffSelected: boolean;
  senderLocation?: string;
  recipientLocation?: string;
  senderAndRecipientSelected: boolean;
  defaultFloor: string;
  currentFloor: string;
  iconType: "2D" | "3D";
  showRobotMap?: boolean; // Optional property to control robot map visibility
}

const initialState: MapState = {
  zoomLevel: 18, // Default zoom level
  mapDetails: [],
  isPickUpSelected: false,
  isDropOffSelected: false,
  senderLocation: "",
  recipientLocation: "",
  senderAndRecipientSelected: false,
  currentFloor: "3",
  defaultFloor: "3",
  iconType: "3D", // Default icon type
  showRobotMap: false, // Initialize with false
};

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    storeMapPoints: (state, action: PayloadAction<MapDetails3[]>) => {
      state.mapDetails = action.payload;
    },
    zoomIn: (state) => {
      state.zoomLevel = Math.min(state.zoomLevel + 1, 22);
    },
    zoomOut: (state) => {
      state.zoomLevel = Math.max(state.zoomLevel - 1, 0);
    },
    setZoomLevel: (state, action: PayloadAction<number>) => {
      state.zoomLevel = action.payload;
    },
    setPickUpSelected: (state, action: PayloadAction<boolean>) => {
      state.isPickUpSelected = action.payload;
    },
    setDropOffSelected: (state, action: PayloadAction<boolean>) => {
      state.isDropOffSelected = action.payload;
    },
    setSenderLocation: (state, action: PayloadAction<string>) => {
      state.senderLocation = action.payload;
    },
    setRecipientLocation: (state, action: PayloadAction<string>) => {
      state.recipientLocation = action.payload;
    },
    setSenderAndRecipientSelected: (state, action: PayloadAction<boolean>) => {
      state.senderAndRecipientSelected = action.payload;
    },
    setCurrentFloor: (state, action: PayloadAction<string>) => {
      state.currentFloor = action.payload
    },
    setDefaultFloor: (state, action: PayloadAction<string>) => {
      state.defaultFloor = action.payload;
    },
    resetFloor: (state) => {
      state.currentFloor = state.defaultFloor || initialState.currentFloor
    },
    setIconType: (state, action: PayloadAction<"2D" | "3D">) => {
      state.iconType = action.payload;
    },
    setShowRobotMap: (state, action: PayloadAction<boolean>) => {
      state.showRobotMap = action.payload;
    }
  },
});

export const {
  zoomIn,
  zoomOut,
  setZoomLevel,
  storeMapPoints,
  setPickUpSelected,
  setDropOffSelected,
  setSenderLocation,
  setRecipientLocation,
  setSenderAndRecipientSelected,
  setCurrentFloor,
  resetFloor,
  setIconType,
  setShowRobotMap,
  setDefaultFloor
} = mapSlice.actions;

export default mapSlice.reducer;
